import { useQuery } from '@tanstack/react-query'

import { releaseNotesClient } from '@/api'

const BASE_QUERY_KEY = releaseNotesClient.QUERY_KEY

export const useReleaseNotes = () => {
  const releaseNotesQuery = useQuery({
    queryKey: BASE_QUERY_KEY,
    queryFn: releaseNotesClient.getReleaseNotes
  })

  return {
    releaseNotes: releaseNotesQuery.data,
    isFetching: releaseNotesQuery.isFetching
  }
}
